import { resolveWalletIconString } from "@layerswap/widget/internal";
export const resolveEVMWalletConnectorIcon = ({ connector, iconUrl }) => {
    return resolveWalletIconString({ id: connector, iconUrl });
};
